import React, { useContext, useState, useEffect } from "react";
import Flex from '@react-css/flex';
import TimeSheetDetalhesContext from "../../contexts/TimeSheetDetalhesContext";
import { getTiposTimesheet } from "../../services/tipoTimesheet";
import { StyledPartialInformacoesTs } from '../../styled-components/StyledPartialInformacoesTs.style';
import { DynamicSelect } from '../DynamicSelect';
import Swal from "sweetalert2";
import api from '../../services/api';
import InputMask from 'react-input-mask';
import { ModalTimeline } from "../../components/ModalTimeline";

export const PartialCriterio = ({isFromProjetoInterno}) => {
    const { timesheet } = useContext(TimeSheetDetalhesContext);

    const [tiposTimesheet, setTiposTimesheet] = useState([]);

    var [tipoTimesheet, setTipoTimesheet] = useState("");
    var [idTipoTimesheet, setIdTipoTimesheet] = useState("");
    var [numeroTimesheet, setNumeroTimesheet] = useState("");
    var [numeroTimesheetOld, setNumeroTimesheetOLd] = useState("");
    const [inputValue, getInputValue] = useState('');
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const tiposTimesheet = await getTiposTimesheet(45);
                if (!!tiposTimesheet) {
                    setTiposTimesheet(tiposTimesheet);
                }
            } catch (error) {
                console.error('Erro:', error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {

        setIdTipoTimesheet(timesheet.timesheet.idTipoTimesheet);
        setTipoTimesheet(timesheet.timesheet.tipoTimesheet);

        setNumeroTimesheet(timesheet?.timesheet?.numeroTimesheet);
        setNumeroTimesheetOLd(timesheet?.timesheet?.numeroTimesheet);


    }, [timesheet]);

    const getTipoTimesheet = (currentValue, value) => {
        var tsResult = tiposTimesheet.filter(function (o) {
            return o.key == value;
        });

        tipoTimesheet = tsResult[0].value;
        idTipoTimesheet = tsResult[0].key;
        setTipoTimesheet(tipoTimesheet);
        setIdTipoTimesheet(idTipoTimesheet);

        submitForm('tipots', {
            idtipoTimeSheet: idTipoTimesheet
        }).then((response) => {
            alertMsg('Sucesso', 'Salvo com sucesso!', true);
        }).catch((error) => {
            alertMsg('Erro', 'Verifique as informações e tente novamente.', false);
        });
    };

    const handleNumeroTs = async (numeroTs, updateInfo = false) => {


        numeroTimesheet = numeroTs;
        setNumeroTimesheet(numeroTs);

        if (updateInfo) {
            submitForm('numeroTs', {
                numeroTimesheet: numeroTimesheet
            }).then((response) => {
                alertMsg('Sucesso', 'Salvo com sucesso!', true);
            }).catch((error) => {

                const errorMsg = error?.response?.data?.notification?.messageReturn ? error.response.data.notification.messageReturn : 'Verifique as informações e tente novamente.';

                if (error.response.status === 412) {
                    setNumeroTimesheet(numeroTimesheetOld);
                }

                alertMsg('Erro', errorMsg, false);
            });
        }
    }

    const submitForm = async (recurso, dataObj) => {
        return api.put(`Timesheet/${timesheet.timesheet.idTimesheet}/${recurso}`, dataObj);
    };

    const alertMsg = (title, text, type) => {
        Swal.fire({
            title: title,
            text: text,
            icon: type ? "success" : "error",
            timer: type ? 2000 : 7000,
            showConfirmButton: type ? false : true
        });
    };

    return (
        <StyledPartialInformacoesTs>
            <div className="card pl-0 pr-0">
                <Flex className="timesheet-more-infs">
                    <Flex.Item className="col-sm-12">
                        <h5 className="title-row-info mb-4">
                            Critério
                        </h5>
                    </Flex.Item>
                </Flex>
                <Flex className="timesheet-more-infs">
                    <Flex.Item className="col-sm-4">
                        <span className="legend-info">Líder</span>
                        <p className="data-info pl-0"> {timesheet.pericia.liderPericia} </p>
                    </Flex.Item>
                    <Flex.Item className="col-sm-4">
                        <span className="legend-info">Laudo</span>
                        <p className="data-info pl-0">{timesheet.pericia.sigla}</p>
                    </Flex.Item>
                    <Flex.Item className="col-sm-4">
                        <span className="legend-info">TimeSheet</span>
                        <p className="data-info pl-0 m-0">
                            <InputMask
                                mask="TS99"
                                type='text'
                                className="input-form-num-ts"
                                name='numeroTimesheet'
                                value={numeroTimesheet}
                                onChange={(event) => handleNumeroTs(event.target.value)}
                                onBlur={(event) => handleNumeroTs(event.target.value, true)}
                        /></p>
                    </Flex.Item>
                </Flex>
                <Flex className="timesheet-more-infs">
                    { isFromProjetoInterno ??
                        <Flex.Item className="col-sm-4">
                            <span className="legend-info">Tipo de Sinistro</span>
                            <p className="data-info pl-0"> {timesheet.pericia.tipoSinistro} </p>                                            
                        </Flex.Item>
                    }

                    <Flex.Item className="col-sm-4">
                        <span className="legend-info">Disciplina</span>
                        <p className="data-info pl-0">{timesheet.disciplina.seguradoNome}</p>
                    </Flex.Item>
                    <Flex.Item className="col-sm-4">
                        <span className="legend-info">Tipo</span>
                        <p className="data-info pl-0 m-0">
                            <DynamicSelect
                                classNameCustom="select-custom-tipo custom-tipo"
                                placeholder={''}
                                valuetext={tipoTimesheet}
                                label={''}
                                name={'idTipoTimesheet'}
                                options={tiposTimesheet}
                                keyValue={'key'}
                                keyLabel={'value'}
                                paramMethod={getTipoTimesheet} />
                        </p>
                    </Flex.Item>
                </Flex>
                {
                    timesheet?.timesheet.totalValorProBono == 'R$ 0,00' && timesheet?.descontoComercial == null && (
                        <>
                            <Flex className="timesheet-more-infs">
                                <Flex.Item className="col-sm-4">
                                    <span className="legend-info">Horas Totais</span>
                                    <p className="data-info p-0 data-info-valor" style={{marginBottom: "13px"}}>{timesheet.timesheet.totalHoras}</p>
                                </Flex.Item>
                                { isFromProjetoInterno ??
                                <Flex.Item className="col-sm-4">
                                    <span className="legend-info">Valor Total</span>
                                    <p className="data-info p-0 data-info-valor m-0">{timesheet.timesheet.totalValor}</p>
                                </Flex.Item>
                                }
                            </Flex>
                        </>
                    )
                }
                {
                    (timesheet?.timesheet.totalValorProBono != 'R$ 0,00' || timesheet?.descontoComercial != null) && (
                        <>
                            <Flex className="timesheet-more-infs">
                                <Flex.Item className="col-sm-3">
                                    <span className="legend-info">Valor Executado</span>
                                    <p className="data-info p-0 data-info-valor m-0">{timesheet.timesheet.valorTotalExecutadoF}</p>
                                </Flex.Item>                                
                                    <Flex.Item className="col-sm-3">
                                        { isFromProjetoInterno ? '' : <div>
                                            <span className="legend-info">Valor P.B</span>
                                            <p className="data-info-valor p-0 m-0 data-info-subtrai">{timesheet?.timesheet?.totalValorProBono}</p>
                                        </div> }
                                    </Flex.Item>
                                    <Flex.Item className="col-sm-3">
                                        { isFromProjetoInterno ? '' : <div>
                                            <span className="legend-info">Desconto {timesheet?.descontoComercial?.porcentagem ? `(${timesheet?.descontoComercial?.desconto}%)` : ''}</span>
                                            <p className="data-info-valor p-0 m-0 data-info-subtrai">{timesheet?.descontoComercial?.valorTotalDesconto || 'R$ 0,00'}</p>
                                        </div> }
                                    </Flex.Item>                                
                                <Flex.Item className="col-sm-3">
                                    <span className="legend-info">Valor Total</span>
                                    <p className="data-info-valor p-0 m-0">{timesheet?.timesheet?.valorTotalGeralFaturado}</p>
                                </Flex.Item>
                            </Flex>
                            <Flex className="timesheet-more-infs">
                                <Flex.Item className="col-sm-3">
                                    <span className="legend-info">Hrs Executadas</span>
                                    <p className="data-info p-0 data-info-valor m-0">{timesheet?.timesheet?.totalHorasExecutadasF}</p>
                                </Flex.Item>                                
                                <Flex.Item className="col-sm-6">
                                    { isFromProjetoInterno ? '' : <div>
                                        <span className="legend-info">Horas P.B</span>
                                        <p className="data-info-valor p-0 m-0 data-info-subtrai">{timesheet?.timesheet?.totalHorasProBono}</p>
                                    </div> }
                                </Flex.Item>                                
                                <Flex.Item className="col-sm-3">
                                    <span className="legend-info">Total Horas</span>
                                    <p className="data-info-valor p-0 m-0">{timesheet?.timesheet?.totalHoras}</p>
                                </Flex.Item>
                            </Flex>
                        </>
                    )
                }
            </div >
        </StyledPartialInformacoesTs>
    );
};
